<div class="login-form-wrapper">
    <div class="login-header">
        <h1 class="login-title">{{ 'LOGIN.TITLE' | translate }}</h1>
        <p class="login-subtitle">{{ 'LOGIN.SUBTITLE' | translate }}</p>
    </div>

    <!-- Toast Notification -->
    <app-toast class="toast-wrapper"></app-toast>



    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
        <!-- Email Field -->
        <div class="form-group">
            <label for="email" class="form-label">
                <span class="required-asterisk">*</span> {{ 'LOGIN.EMAIL' | translate }}
            </label>
            <div class="input-wrapper">
                <input type="email" id="email" formControlName="email" class="form-control"
                    [class.is-invalid]="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"
                    [placeholder]="'LOGIN.EMAIL_PLACEHOLDER' | translate" />
                <i class="bi bi-exclamation-triangle input-error-icon"
                    *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched"></i>
            </div>
            <div class="invalid-feedback" *ngIf="loginForm.get('email')?.invalid && loginForm.get('email')?.touched">
                {{ getErrorMessage('email') }}
            </div>
        </div>

        <!-- Password Field -->
        <div class="form-group">
            <label for="password" class="form-label">
                <span class="required-asterisk">*</span> {{ 'LOGIN.PASSWORD' | translate }}
            </label>
            <div class="password-input-wrapper">
                <input [type]="showPassword ? 'text' : 'password'" id="password" formControlName="password"
                    class="form-control"
                    [class.is-invalid]="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"
                    [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate" />
                <i class="bi bi-exclamation-triangle input-error-icon"
                    *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched"></i>
                <button type="button" class="password-toggle" (click)="togglePasswordVisibility()"
                    [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'">
                    <i class="bi" [class.bi-eye]="!showPassword" [class.bi-eye-slash]="showPassword"></i>
                </button>
            </div>
            <div class="invalid-feedback"
                *ngIf="loginForm.get('password')?.invalid && loginForm.get('password')?.touched">
                {{ getErrorMessage('password') }}
            </div>
        </div>

        <!-- Forgot Password Link -->
        <div class="forgot-password-wrapper">
            <a href="javascript:void(0)" class="forgot-password-link" (click)="onForgotPasswordClick()">
                {{ 'LOGIN.FORGOT_PASSWORD' | translate }}
            </a>
        </div>

        <!-- Sign In Button -->
        <button type="submit" class="btn btn-primary btn-sign-in" [disabled]="isLoading">
            <span *ngIf="!isLoading">{{ 'LOGIN.SIGN_IN' | translate }}</span>
            <span *ngIf="isLoading">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Loading...
            </span>
        </button>

        <!-- Divider -->
        <div class="divider">
            <span class="divider-text">{{ 'LOGIN.OR' | translate }}</span>
        </div>

        <!-- Microsoft Sign In Button -->
        <button type="button" class="btn btn-microsoft" (click)="onMicrosoftLoginClick()" [disabled]="isLoading">
            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="1" y="1" width="9" height="9" fill="#F25022" />
                <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
                <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
                <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
            </svg>
            <span>{{ 'LOGIN.SIGN_IN_WITH_MICROSOFT' | translate }}</span>
        </button>
    </form>
</div>